const pollMixin = {
    methods: {
        pollGetResponseRequired(quorum) {
            return parseInt(quorum * 100);
        },
        pollGetAnswerPercentage(value) {
            const valueToNumber = Number(value);

            if (valueToNumber > 0) {
                if (Number.isInteger(valueToNumber)) {
                    return valueToNumber;
                }

                return parseFloat(valueToNumber.toFixed(2));
            }

            return 0;
        },
    },
};

export default pollMixin;